import { getScrollY } from './scrollPosition';

const $window = $(window);
let lastScrollTop = -1;

const scrollListener = {
  start() {
    this.check();
  },

  check() {
    const scrollTop = getScrollY();

    if (lastScrollTop !== scrollTop) {
      lastScrollTop = scrollTop;
      $window.trigger('scroll:virtual', lastScrollTop);
    }

    requestAnimationFrame(this.check.bind(this));
  },
};

export default scrollListener;
